export default __webpack_public_path__ + "static/media/smallgoods_hero.2e4efa7a.jpg";